import React, { useEffect, useState } from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import { opcoesProdutos } from './utils';
import { validaEmail } from '../../libs/util/utils';

const PAGINA_ENVIA_EMAIL = 'https://ideia2001.com.br/EnviaEmailIdeia2001.asp';
const EMAIL_COMERCIAL = 'comercial@ideia2001.com.br';
const EMAIL_CONTATO = 'contato@ideia2001.com.br';

export default ({ formOrcamento }) => {
  const intl = useIntl();

  const [enviandoFormulario, setEnviandoFormulario] = useState(false);
  const [exibeMsgSucesso, setExibeMsgSucesso] = useState(false);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [emailVazio, setEmailVazio] = useState(false);
  const [emailInvalido, setEmailInvalido] = useState(false);
  const [telefone, setTelefone] = useState('');
  const [telefoneVazio, setTelefoneVazio] = useState(false);
  const [catalogo, setCatalogo] = useState(opcoesProdutos.vazio.value);
  const [catalogoVazio, setCatalogoVazio] = useState(false);
  const [mensagem, setMensagem] = useState('');

  // seta catalogo de acordo com o parametro interesse na url
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const interesseParam = params.get('interesse');

    if (!interesseParam) return;

    const configInteresse = Object
      .values(opcoesProdutos)
      .find((opcao) => opcao.param === interesseParam);

    if (!configInteresse) return;

    setCatalogo(configInteresse.value);
  }, []);

  useEffect(() => {
    document.querySelector('.wpcf7-form').setAttribute('action', 'https://ideia2001.com.br/enviaEmail.asp');
  }, []);

  let timeoutMsgEmail;
  let timeoutMsgTelefone;
  let timeoutMsgCatalogo;

  const limpaCampos = () => {
    setNome('');
    setEmail('');
    setTelefone('');
    if (formOrcamento) setCatalogo(opcoesProdutos.vazio.value);
    setMensagem('');
  };

  const formularioValido = (valores) => {
    if (!valores.email) {
      setEmailVazio(true);
      clearTimeout(timeoutMsgEmail);
      timeoutMsgEmail = setTimeout(() => {
        setEmailVazio(false);
      }, 3000);
      return false;
    }
    if (!valores.telefone) {
      setTelefoneVazio(true);
      clearTimeout(timeoutMsgTelefone);
      timeoutMsgTelefone = setTimeout(() => {
        setTelefoneVazio(false);
      }, 3000);
      return false;
    }
    if (formOrcamento && catalogo === opcoesProdutos.vazio.value) {
      setCatalogoVazio(true);
      clearTimeout(timeoutMsgCatalogo);
      timeoutMsgCatalogo = setTimeout(() => {
        setCatalogoVazio(false);
      }, 3000);
      return false;
    }
    if (!validaEmail(valores.email)) {
      setEmailInvalido(true);
      clearTimeout(timeoutMsgEmail);
      timeoutMsgEmail = setTimeout(() => {
        setEmailInvalido(false);
      }, 3000);
      return false;
    }
    return true;
  };

  const enviaFormulario = async (valores) => {
    setEnviandoFormulario(true);
    let bodyEmail = '';
    if (valores.nome) bodyEmail = `${bodyEmail}<strong>Nome:</strong> ${valores.nome}<br>`;
    if (valores.email) bodyEmail = `${bodyEmail}<strong>E-mail:</strong> ${valores.email}<br>`;
    if (valores.telefone) bodyEmail = `${bodyEmail}<strong>Telefone:</strong> ${valores.telefone}<br>`;
    if (valores.catalogo) bodyEmail = `${bodyEmail}<strong>Catálogo:</strong> ${valores.catalogo}<br>`;
    if (valores.mensagem) bodyEmail = `${bodyEmail}<strong>Mensagem:</strong> ${valores.mensagem}`;
    const data = {
      From: formOrcamento ? EMAIL_COMERCIAL : EMAIL_CONTATO,
      To: formOrcamento ? EMAIL_COMERCIAL : EMAIL_CONTATO,
      Subject: 'Ideia 2001 ' + (valores.nome || ''),
      Body: bodyEmail,
    };

    const searchParams = Object.keys(data)
      .map((prop) => `${encodeURIComponent(prop)}=${encodeURIComponent(data[prop])}`)
      .join('&');

    try {
      const rawResponse = await window.fetch(PAGINA_ENVIA_EMAIL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: searchParams,
      });

      return rawResponse.text();
    } catch (e) {
      return '';
    }
  };

  const formularioEnviado = () => {
    limpaCampos();
    setEnviandoFormulario(false);
    setExibeMsgSucesso(true);
    setTimeout(() => {
      setExibeMsgSucesso(false);
    }, 3000);
  };

  const tentaEnviarFormulario = async (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    event.preventDefault();

    const valores = {
      nome,
      email,
      telefone,
      catalogo: formOrcamento ? catalogo : '',
      mensagem,
    };
    if (formularioValido(valores)) {
      await enviaFormulario(valores);
      formularioEnviado();
    }
  };

  return (
    <div role="form" className="wpcf7" id="wpcf7-f103-p116-o1" dir="ltr">
      <form className="wpcf7-form sent" noValidate>
        <p>
          <span className="wpcf7-form-control-wrap nome">
            <input
              type="text"
              name="nome"
              size="40"
              className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
              aria-required="true"
              aria-invalid="false"
              placeholder={intl.formatMessage({ id: 'Nome' })}
              id="input-nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
          </span>
          <br />
          <span className="wpcf7-form-control-wrap e-mail">
            <input
              type="email"
              name="e-mail"
              size="40"
              className={`wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email ${emailVazio || emailInvalido ? 'invalid' : ''}`}
              aria-required="true"
              aria-invalid="false"
              placeholder={intl.formatMessage({ id: 'E-mail' })}
              id="input-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {emailVazio ? (
              <span style={{ color: 'red' }} id="msg-email-vazio">{intl.formatMessage({ id: 'E-mail deve ser preenchido' })}</span>
            ) : null}
            {emailInvalido ? (
              <span style={{ color: 'red' }} id="msg-email-invalido">{intl.formatMessage({ id: 'E-mail inválido' })}</span>
            ) : null}
          </span>
          <br />
          <span className="wpcf7-form-control-wrap tel">
            <input
              type="tel"
              name="tel"
              size="40"
              className={`wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel ${telefoneVazio ? 'invalid' : ''}`}
              aria-required="true"
              aria-invalid="false"
              placeholder={intl.formatMessage({ id: 'Telefone' })}
              id="input-telefone"
              value={telefone}
              onChange={(e) => setTelefone(e.target.value)}
            />
            {telefoneVazio ? (
              <span style={{ color: 'red' }} id="msg-telefone-vazio">{intl.formatMessage({ id: 'Telefone deve ser preenchido' })}</span>
            ) : null}
          </span>
          <br />

          {formOrcamento ? (
            <>
              <span className="wpcf7-form-control-wrap menu-941">
                <select
                  name="menu-941"
                  className={`wpcf7-form-control wpcf7-select wpcf7-validates-as-required ${catalogoVazio ? 'invalid' : ''}`}
                  style={{ fontStyle: catalogo === opcoesProdutos.vazio.value ? 'italic' : 'normal' }}
                  aria-required="true"
                  aria-invalid="false"
                  id="select-catalogo"
                  value={catalogo}
                  onBlur={(e) => setCatalogo(e.target.value)}
                  onChange={(e) => setCatalogo(e.target.value)}
                >
                  {Object.values(opcoesProdutos).map((opcao) => (
                    <option
                      key={opcao.value}
                      value={opcao.value}
                      style={{
                        fontStyle: opcao.value === opcoesProdutos.vazio.value ? 'italic' : 'normal',
                      }}
                    >
                      {intl.formatMessage({ id: opcao.label })}
                    </option>
                  ))}
                </select>
                {catalogoVazio ? (
                  <span style={{ color: 'red' }} id="msg-produto-vazio">{intl.formatMessage({ id: 'Produto deve ser preenchido' })}</span>
                ) : null}
              </span>
              <br />
            </>
          ) : null}

          <span className="wpcf7-form-control-wrap msg">
            <textarea
              name="msg"
              cols="40"
              rows="10"
              className="wpcf7-form-control wpcf7-textarea wpcf7-validates-as-required"
              aria-required="true"
              aria-invalid="false"
              placeholder={intl.formatMessage({ id: 'Mensagem' })}
              style={{ marginTop: 10, marginBottom: 10, height: 225 }}
              id="textarea-mensagem"
              value={mensagem}
              onChange={(e) => setMensagem(e.target.value)}
            ></textarea>
          </span>
          <br />
          <input
            type="submit"
            id="button-submit"
            value={intl.formatMessage({ id: 'Enviar' })}
            className="wpcf7-form-control wpcf7-submit enviar"
            onClick={tentaEnviarFormulario}
            onKeyDown={tentaEnviarFormulario}
          />
        </p>
        <div style={{ clear: 'both', textAlign: 'center' }}>
          <span className="ajax-loader" id="spinner-loading" style={{ visibility: enviandoFormulario ? '' : 'hidden' }}></span>
        </div>
        <div className="wpcf7-response-output wpcf7-display-none wpcf7-mail-sent-ok" style={{ display: 'block', visibility: exibeMsgSucesso ? '' : 'hidden' }} role="alert" id="mensagem-sucesso">
          {intl.formatMessage({ id: 'Agradecemos a sua mensagem' })}.
        </div>
      </form>
    </div>
  );
};
